import { render } from "./MobileHome.vue?vue&type=template&id=2007c063&scoped=true"
import script from "./MobileHome.vue?vue&type=script&lang=js"
export * from "./MobileHome.vue?vue&type=script&lang=js"

import "./MobileHome.vue?vue&type=style&index=0&id=2007c063&scoped=true&lang=css"

import exportComponent from "/home/ak/projects/ysm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2007c063"]])

export default __exports__